/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import _ from 'lodash';
import {
  deleteGalleryById,
  deleteImageByGalleryId,
  loadGalleries,
  loadGalleriesByPage,
  loadGalleryById,
  newGallery,
  saveGallery,
  saveOrder,
  searchGalleryByName,
  updateImageMetaByGalleryId,
} from '@/gallery/api';

const state = {
  currentGallery: {},
  selectedGallery: {},
  currentGalleryWasEdited: {
    wasEdited: false,
    wasReordered: false,
    toBeDeleted: [],
    modifiedItem: [],
    errors: [],
  },
  galleries: {
    data: {},
    total: 0,
    perPage: 0,
    lastPage: 0,
    currentPage: 1,
  },
  galleriesForModal: {
    data: {},
    total: 0,
    perPage: 0,
    lastPage: 0,
    currentPage: 1,
  },
  galleryActiveModal: null,
  galleryEmptySearchResult: false,
  deleteGalleryState: {
    isDeleting: false,
    isDeleted: false,
    error: null,
  },
  loadGalleriesState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  loadCurrentGalleryState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  loadSelectedGalleryState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  createGalleryState: {
    isCreating: false,
    isCreated: false,
    error: null,
  },
  saveGalleryState: {
    isSaving: false,
    isSaved: false,
    error: null,
  },
};

const initialState = {
  currentGallery: {},
  selectedGallery: {},
  currentGalleryWasEdited: {
    wasEdited: false,
    wasReordered: false,
    toBeDeleted: [],
    modifiedItem: [],
    errors: [],
  },
  galleries: {
    data: {},
    total: 0,
    perPage: 0,
    lastPage: 0,
    currentPage: 1,
  },
  galleriesForModal: {
    data: {},
    total: 0,
    perPage: 0,
    lastPage: 0,
    currentPage: 1,
  },
  galleryActiveModal: null,
  galleryEmptySearchResult: false,
  deleteGalleryState: {
    isDeleting: false,
    isDeleted: false,
    error: null,
  },
  loadGalleriesState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  loadCurrentGalleryState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  loadSelectedGalleryState: {
    isLoading: false,
    error: {
      message: null,
      statusCode: null,
    },
  },
  createGalleryState: {
    isCreating: false,
    isCreated: false,
    error: null,
  },
  saveGalleryState: {
    isSaving: false,
    isSaved: false,
    error: null,
  },
};

const getters = {
  createGalleryState: (state) => state.createGalleryState,
  currentGallery: (state) => state.currentGallery,
  currentGalleryWasEdited: (state) => state.currentGalleryWasEdited,
  deleteGalleryState: (state) => state.deleteGalleryState,
  galleries: (state) => state.galleries,
  galleriesForModal: (state) => state.galleriesForModal,
  galleryActiveModal: (state) => state.galleryActiveModal,
  galleryEmptySearchResult: (state) => state.galleryEmptySearchResult,
  loadCurrentGalleryState: (state) => state.loadCurrentGalleryState,
  loadSelectedGalleryState: (state) => state.loadSelectedGalleryState,
  loadGalleriesState: (state) => state.loadGalleriesState,
  saveGalleryState: (state) => state.saveGalleryState,
  selectedGallery: (state) => state.selectedGallery,
};

const mutations = {
  async createGalleryByName(state, galleryName) {
    state.createGalleryState.isCreating = true;
    try {
      const response = await newGallery({ title: galleryName });
      state.currentGallery = response.data;
      state.selectedGallery = response.data;
      state.createGalleryState.isCreated = true;
    } catch (error) {
      state.createGalleryState.error = error.response;
    }
    state.createGalleryState.isCreating = false;
  },
  async createGalleryOnModal(state, galleryName) {
    state.createGalleryState.isCreating = true;
    try {
      const response = await newGallery({ title: galleryName });
      state.selectedGallery = response.data;
      state.createGalleryState.isCreated = true;
    } catch (error) {
      state.createGalleryState.error = error.response;
    }
    state.createGalleryState.isCreating = false;
  },
  async deleteCurrentGallery(state, galleryKey) {
    state.deleteGalleryState.isDeleting = true;
    try {
      await deleteGalleryById(galleryKey);
      state.deleteGalleryState.isDeleted = true;
      state.galleries = {};
    } catch (error) {
      state.deleteGalleryState.error = error.response;
    }
    state.deleteGalleryState.isDeleting = false;
  },
  async loadAllGalleries(state, filter) {
    state.loadGalleriesState.isLoading = true;
    try {
      const response = await loadGalleries(filter);
      state.galleries.data = response.data.data;
      state.galleries.total = response.data.total;
      state.galleries.perPage = response.data.perPage;
      state.galleries.lastPage = response.data.lastPage;
    } catch (error) {
      state.loadGalleriesState.error.statusCode = error.response.data.statusCode;
      state.loadGalleriesState.error.message = error.response.data.message;
    }
    state.loadGalleriesState.isLoading = false;
  },
  async loadAllGalleriesForModal(state, page) {
    state.loadGalleriesState.isLoading = true;
    try {
      const response = await loadGalleriesByPage(page);
      state.galleriesForModal.data = response.data.data;
      state.galleriesForModal.total = response.data.total;
      state.galleriesForModal.perPage = response.data.perPage;
      state.galleriesForModal.lastPage = response.data.lastPage;
      state.galleriesForModal.currentPage = page;
    } catch (error) {
      state.loadGalleriesState.error = error.response.data.message;
    }
    state.loadGalleriesState.isLoading = false;
  },
  async loadCurrentGallery(state, galleryKey) {
    state.currentGallery = {};
    state.loadCurrentGalleryState.isLoading = true;
    try {
      const response = await loadGalleryById(galleryKey);
      state.currentGallery = response.data;
    } catch (error) {
      state.loadCurrentGalleryState.error.message = error.response.data.message;
      state.loadCurrentGalleryState.error.statusCode = error.response.data.statusCode;
    }
    state.loadCurrentGalleryState.isLoading = false;
  },
  async loadSelectedGallery(state, galleryKey) {
    state.selectedGallery = {};
    state.loadSelectedGalleryState.isLoading = true;
    try {
      const response = await loadGalleryById(galleryKey);
      state.selectedGallery = response.data;
    } catch (error) {
      state.loadSelectedGalleryState.error.message = error.response.data.message;
      state.loadSelectedGalleryState.error.statusCode = error.response.data.statusCode;
    }
    state.loadSelectedGalleryState.isLoading = false;
  },
  async saveCurrentGallery(state) {
    state.saveGalleryState.isSaving = true;
    const galleryId = state.currentGallery.id;
    try {
      // SAVE ORDER IF IT WAS CHANGED
      if (state.currentGalleryWasEdited.wasReordered) {
        await saveOrder(galleryId, { itemIds: state.currentGallery.itemIds });
      }
      // DELETE IMAGES IF EXISTS
      await state.currentGalleryWasEdited.toBeDeleted.forEach((imageId) => {
        if (imageId) {
          deleteImageByGalleryId(galleryId, imageId);
        }
      });
      // UPDATE ONLY MODIFIED IMAGE'S METAS
      await state.currentGalleryWasEdited.modifiedItem.forEach((image) => {
        updateImageMetaByGalleryId(galleryId, image.id, {
          title: image.title,
          description: image.description,
          image: image.image,
        });
      });
      // FINALLY SAVE THE GALLERY
      const galleryResponse = await saveGallery(galleryId, state.currentGallery);
      state.currentGallery = galleryResponse.data;
      state.saveGalleryState.isSaved = true;
    } catch (error) {
      state.saveGalleryState.error = error.response;
    }
    state.saveGalleryState.isSaving = false;
  },
  async saveSelectedGallery(state) {
    state.saveGalleryState.isSaving = true;
    const galleryId = state.selectedGallery.id;
    try {
      // SAVE ORDER IF IT WAS CHANGED
      if (state.currentGalleryWasEdited.wasReordered) {
        await saveOrder(galleryId, { itemIds: state.selectedGallery.itemIds });
      }
      // DELETE IMAGES IF EXISTS
      await state.currentGalleryWasEdited.toBeDeleted.forEach((imageId) => {
        if (imageId) {
          deleteImageByGalleryId(galleryId, imageId);
        }
      });
      // UPDATE ONLY MODIFIED IMAGE'S METAS
      await state.currentGalleryWasEdited.modifiedItem.forEach((image) => {
        updateImageMetaByGalleryId(galleryId, image.id, {
          title: image.title,
          description: image.description,
          image: image.image,
        });
      });
      // FINALLY SAVE THE GALLERY
      const galleryResponse = await saveGallery(galleryId, state.selectedGallery);
      state.selectedGallery = galleryResponse.data;
      state.currentGallery = galleryResponse.data;
      state.loadCurrentGalleryState = {
        isLoading: false,
        error: {
          message: null,
          statusCode: null,
        },
      };
    } catch (error) {
      state.saveGalleryState.error = error.response;
    }
    state.saveGalleryState.isSaving = false;
  },
  async searchGalleryForModal(state, galleryName) {
    try {
      const response = await searchGalleryByName(galleryName);
      state.galleriesForModal.data = response.data.data;
      state.galleriesForModal.lastPage = response.data.lastPage;
      state.galleryEmptySearchResult = response.data.data.length === 0;
    } catch (error) {
      state.loadGalleriesState.error = error.response;
    }
  },
  destroyCurrentGalleryState(state) {
    state.currentGallery = {};
    state.currentGalleryWasEdited = {
      wasEdited: false,
      toBeDeleted: [],
      modifiedItem: [],
      errors: [],
    };
  },
  pushCurrentGalleryError(state, error) {
    state.currentGalleryWasEdited.errors.push(error);
  },
  pushCurrentGalleryToBeDeleted(state, itemId) {
    state.currentGalleryWasEdited.toBeDeleted.push(itemId);
  },
  resetGalleryState(state) {
    state.currentGallery = {};
    state.selectedGallery = {};
    state.currentGalleryWasEdited = {
      wasEdited: false,
      wasReordered: false,
      toBeDeleted: [],
      modifiedItem: [],
      errors: [],
    };
    state.deleteGalleryState = {
      isDeleting: false,
      isDeleted: false,
      error: null,
    };
    state.loadCurrentGalleryState = {
      isLoading: false,
      error: {
        message: null,
        statusCode: null,
      },
    };
    state.loadSelectedGalleryState = state.loadCurrentGalleryState;
    state.createGalleryState = {
      isCreating: false,
      isCreated: false,
      error: null,
    };
    state.saveGalleryState = {
      isSaving: false,
      isSaved: false,
      error: null,
    };
  },
  resetAllGalleryState(state) {
    Object.assign(state, initialState);
  },
  resetCreateGalleryState(state) {
    state.createGalleryState = {
      isCreating: false,
      isCreated: false,
      error: null,
    };
    state.currentGallery = {};
  },
  resetCurrentGalleryErrors(state) {
    state.currentGalleryWasEdited.errors = [];
  },
  setCurrentGallery(state, gallery) {
    state.currentGallery = gallery;
  },
  setCurrentGalleryModifiedItem(state, itemId) {
    state.currentGalleryWasEdited.modifiedItem.push(itemId);
    state.currentGalleryWasEdited.modifiedItem = _.union(state.currentGalleryWasEdited.modifiedItem);
  },
  setCurrentGalleryWasEdited(state) {
    state.currentGalleryWasEdited.wasEdited = true;
  },
  setCurrentGalleryWasReordered(state) {
    state.currentGalleryWasEdited.wasReordered = true;
  },
  setGalleryActiveModal(state, modalName) {
    state.galleryActiveModal = modalName;
  },
  setSelectedGallery(state, gallery) {
    state.selectedGallery = gallery;
  },
  updateGalleryDescription(state, description) {
    state.currentGallery.description = description;
  },
  updateGalleryTitle(state, title) {
    state.currentGallery.title = title;
  },
};

const actions = {
  createGalleryByName({ commit }, galleryName) {
    commit('createGalleryByName', galleryName);
  },
  createGalleryOnModal({ commit }, galleryName) {
    commit('createGalleryOnModal', galleryName);
  },
  deleteCurrentGallery({ commit, dispatch }, galleryKey) {
    commit('deleteCurrentGallery', galleryKey);
    dispatch('loadAllGalleries', null);
  },
  destroyCurrentGalleryState({ commit }) {
    commit('destroyCurrentGalleryState');
  },
  dismissCreateGalleryModal({ commit }) {
    commit('setGalleryActiveModal', null);
    commit('resetGalleryState');
  },
  loadAllGalleries({ commit }, filter) {
    commit('resetAllGalleryState');
    commit('loadAllGalleries', filter);
  },
  loadAllGalleriesWithoutResetting({ commit }, filter) {
    commit('loadAllGalleries', filter);
  },
  loadAllGalleriesForModal({ commit }, page) {
    commit('resetGalleryState');
    commit('loadAllGalleriesForModal', page);
  },
  loadCurrentGallery({ commit }, galleryKey) {
    commit('resetGalleryState');
    commit('loadCurrentGallery', galleryKey);
  },
  loadSelectedGallery({ commit }, galleryKey) {
    commit('loadSelectedGallery', galleryKey);
  },
  pushCurrentGalleryError({ commit }, error) {
    commit('pushCurrentGalleryError', error);
  },
  pushCurrentGalleryToBeDeleted({ commit }, itemId) {
    commit('pushCurrentGalleryToBeDeleted', itemId);
  },
  resetAllGalleryState({ commit }) {
    commit('resetAllGalleryState');
  },
  resetCreateGalleryState({ commit }) {
    commit('resetCreateGalleryState');
  },
  resetCurrentGalleryErrors({ commit }) {
    commit('resetCurrentGalleryErrors');
  },
  saveCurrentGallery({ commit }) {
    commit('saveCurrentGallery');
  },
  saveSelectedGallery({ commit }) {
    commit('saveSelectedGallery');
  },
  searchGalleryForModal({ commit }, galleryName) {
    commit('searchGalleryForModal', galleryName);
  },
  setCurrentGallery({ commit }, gallery) {
    commit('setCurrentGallery', gallery);
  },
  setCurrentGalleryModifiedItem({ commit }, itemId) {
    commit('setCurrentGalleryModifiedItem', itemId);
  },
  setCurrentGalleryWasEdited({ commit }) {
    commit('setCurrentGalleryWasEdited');
  },
  setCurrentGalleryWasReordered({ commit }) {
    commit('setCurrentGalleryWasReordered');
  },
  setGalleryActiveModal({ commit }, modalName) {
    commit('setGalleryActiveModal', modalName);
  },
  setSelectedGallery({ commit }, gallery) {
    commit('setSelectedGallery', gallery);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
